<template>
  <Dialog
    v-model:visible="visible"
    :modal="true"
    :closable="false"
    :dismissableMask="false"
    :style="{ width: '100vw', height: '100%', maxWidth: '100vw', maxHeight: '100%', margin: 0 }"
    class="signature-dialog"
  >
    <SignatureCapture
      :title="title"
      :subtitle="subtitle"
      :legal-declaration="legalDeclaration"
      @save="onSave"
      @cancel="onCancel"
    />
  </Dialog>
</template>

<script setup lang="ts">
import { ref, watch, computed } from 'vue'
import Dialog from 'primevue/dialog'
import SignatureCapture from './SignatureCapture.vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: 'Declaration of Ownership',
  },
  subtitle: {
    type: String,
    default: '',
  },
  showLegalDeclaration: {
    type: Boolean,
    default: true,
  },
  transactionType: {
    type: String,
    default: 'purchase',
  },
})

const emit = defineEmits(['update:modelValue', 'save'])

const visible = ref(props.modelValue)

// Compute the legal declaration based on transaction type
const legalDeclaration = computed(() => {
  if (!props.showLegalDeclaration) return ''

  if (props.transactionType === 'purchase') {
    return 'I hereby affirm that I am the rightful owner of the hereon described merchandise; or I am an authorized representative of the rightful owner and affirm that I have been given authority by the rightful owner to sell the hereon described merchandise.\n\nI state under penalty of perjury under the laws of Oklahoma that the foregoing is true and correct.'
  }

  return '' // For sales transactions, no declaration needed
})

watch(
  () => props.modelValue,
  (newValue) => {
    visible.value = newValue
  },
)

watch(visible, (newValue) => {
  emit('update:modelValue', newValue)
})

function onSave(signatureData: any) {
  emit('save', signatureData)
  visible.value = false
}

function onCancel() {
  visible.value = false
}
</script>

<style>
.signature-dialog {
  padding: 0 !important;
}

.signature-dialog .p-dialog-content {
  padding: 0 !important;
  overflow: auto;
}

/* Remove dialog header */
.signature-dialog .p-dialog-header {
  display: none;
}

/* Make dialog content take full height */
.signature-dialog .p-dialog-content {
  height: 100%;
}
</style>
